import React, { FunctionComponent, useEffect, useState } from 'react';
import { AppBar, Box, Button, Link, styled, Toolbar, Typography, useTheme } from '@mui/material';
import { blueGrey, orange } from '@mui/material/colors';
import ImageImports from '../../utils/ImageImports';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useIsInternalAdmin } from '../../customHooks/useIsInternalAdmin';

export const cpUrl = process.env.REACT_APP_CP_URL as string;
const RedirectContainer: FunctionComponent = () => {
  const theme = useTheme();

  const { ugLogo } = ImageImports;
  const H1 = styled(Typography)(({ theme }) => ({
    color: blueGrey[600],
    alignItems: 'center',
    fontSize: '2.25rem',
    fontWeight: 'bold',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.25rem'
    }
  }));

  const Paragraph = styled(Typography)(({ theme }) => ({
    fontSize: '1.25rem',
    color: theme.palette.secondary.dark,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem'
    }
  }));

  const [seconds, setSeconds] = useState(10);
  useEffect(() => {
    const myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }
      if (seconds === 0) {
        clearInterval(myInterval);
        console.log('redirecting now');
        handleRedirect();
      }
    }, 1000);
    return () => {
      clearInterval(myInterval);
    };
  }, [seconds]);

  const handleRedirect = () => {
    window.location.replace(cpUrl);
  };

  const handleBypassRedirect = () => {
    sessionStorage.setItem('bypassRedirect', 'true');
    window.location.reload();
  };

  const isInternalAdmin = useIsInternalAdmin();

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      <AppBar
        position="fixed"
        sx={{ backgroundColor: theme.palette.background.paper, boxShadow: theme.shadows[3] }}
      >
        <Toolbar>
          <Box sx={{ flexGrow: 1 }}>
            <img
              src={ugLogo}
              className="App-logo ml-0 lg:ml-6"
              alt="logo"
            />
          </Box>
        </Toolbar>
      </AppBar>
      <Box sx={{ backgroundColor: blueGrey[50], height: '100%', flexGrow: 1 }}>
        <section className="min-h-screen grid place-items-center pt-[30px] md:pt-[60px]">
          <div className="container mx-auto">
            <div className="text-center p-5 my-1 md:my-5">
              <div className="my-6 max-w-xl mx-auto [text-wrap:_balance]">
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2, fontSize: '3rem' }}>
                  <InfoOutlinedIcon
                    fontSize="inherit"
                    sx={{ color: orange[600] }}
                  />
                  <H1>User Group Portal has Moved!</H1>
                </Box>
              </div>

              <div className="text-foreground max-w-xl mx-auto [text-wrap:_balance]">
                <Paragraph>User Group Portal has moved to a new location. Please update your bookmarks accordingly.</Paragraph>

                {seconds > 0 ? (
                  <Paragraph sx={{ fontSize: '1rem', my: 3 }}>
                    You will be automatically redirected in <strong>{seconds}</strong> seconds, or click the button below to go to the new Portal.
                  </Paragraph>
                ) : (
                  <Paragraph sx={{ fontSize: '1rem', my: 3 }}>Click the button below to go to the new Portal</Paragraph>
                )}
                <Box sx={{ textAlign: 'center', my: 4, display: 'flex', justifyContent: 'center', flexDirection: { xs: 'column', md: 'row' }, gap: 4 }}>
                  <Button
                    component={Link}
                    href={cpUrl}
                    aria-label={`Go to New Portal`}
                    color="info"
                    variant="contained"
                  >
                    Go to New Portal
                  </Button>
                  {isInternalAdmin && (
                    <Button
                      aria-label={`Go to New Portal`}
                      color="warning"
                      variant="contained"
                      onClick={() => handleBypassRedirect()}
                    >
                      Stay on User Group Portal
                    </Button>
                  )}
                </Box>
              </div>
            </div>
          </div>
        </section>
      </Box>
    </Box>
  );
};

export default RedirectContainer;
